"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateRoleUpdate = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const roleUpdateMutation = (0, client_1.gql) `
  mutation RoleUpdate($workspaceId: ID!, $userId: ID!, $data: RoleInputData) {
    roleUpdate(workspace: $workspaceId, user: $userId, data: $data) {
      hidden
      calendarOrder
      cycleGroup
      cycleGroupName
      cycleId
    }
  }
`;
const mutateRoleUpdate = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(roleUpdateMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.roleUpdate;
};
exports.mutateRoleUpdate = mutateRoleUpdate;
